import { HomeService } from './../../services/home/home.service';
import { Component, OnInit } from '@angular/core';
import { makeStateKey, Meta, Title, TransferState } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  title = 'شركة متخصصة في برمجة التطبيقات والمواقع الالكترونية وانظمة الادارة';
  data: any;
  slides: any;
  works: any;
  isLoading = true;
  isData = false;

  constructor(private service: HomeService, private titleService: Title,private metaService:Meta,    private state: TransferState) { }

  async ngOnInit(): Promise<void> {
    this.metaService.addTag( { name:'description',content:"شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات"});
    this.metaService.addTag( { name:'og:description',content:"شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات"});
    this.metaService.addTag( { name:'twitter:description',content:"شركة كودس روتس هي شركة متخصصه في تصميم المواقع وتطبيقات الجوال نتميز بفضل الله باستخدام احدث اللغات والتقنيات في تصميم المواقع والتطبيقات"});
    this.metaService.addTag( { name:'keywords',content:"تصميم مواقع باحترافية,شركة تصميم مواقع في السعودية,تصميم مواقع,تصميم تطبيقات الجوال,افضل شركة لتصميم المواقع ,افضل شركة لبرمجه التطبيقات,تصميم تطبيقات اندرويد"});

    this.titleService.setTitle(this.title);
    await this.getSlider();


  }
  async getSlider() {
 await  this.service.getSlides().subscribe(e=>{
  this.slides = e.data;
  this.isLoading = false;
  this.isData = true;
 })

  }

  

}
